// The shared Floodlight product mark — official "F" logo asset.
import React from "react";

export const SoubourMark = ({ size = 22, className = "", testId = "floodlight-mark" }) => (
    <img
        data-testid={testId}
        src="/floodlight-logo.png"
        alt="Floodlight"
        width={size}
        height={size}
        className={`inline-block object-contain ${className}`}
        draggable="false"
    />
);

export const SouburWordmark = ({ product = "", className = "", testId = "floodlight-wordmark", animated = false }) => (
    <span
        data-testid={testId}
        className={`inline-flex items-center gap-2.5 font-sport text-white ${animated ? "logo-switch-on" : ""} ${className}`}
    >
        <SoubourMark size={22} />
        <span className="text-[1.05rem] leading-none tracking-tightest uppercase">
            FLOODLIGHT<span className="text-[var(--sb-amber)]">.</span>
            {product && <span className="font-display font-semibold tracking-tight normal-case">{product.toLowerCase()}</span>}
        </span>
    </span>
);

// Backwards-compat export aliases (so imports don't have to change).
export const FloodlightMark = SoubourMark;
export const FloodlightWordmark = SouburWordmark;
